
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsofuse",
      function () {
        return require("private-next-pages/termsofuse/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsofuse"])
      });
    }
  